import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';
import StyledComponent from 'styled-components';

import CsvButton from './CsvButton';
import DeleteButton from './DeleteButton';

const headerBg = '#FFE2EC';
const headerText = '#F50057';

const Container = StyledComponent.div`
  .table-header-selected
  {
    color: ${headerText};
    background-color: ${headerBg};
  }
  .table-header
  {
    padding-left: 16px;
    padding-right: 8px;
  }
  .table-header-title
  {
    flex: 1;
  }
`;

type EnhancedTableToolbarProps = {
  createButtonOnClick: () => void;
  updateButtonOnClick: () => void;
  selected: any[];
  isUpdateAvailable?: boolean;
  isCreateAvailable?: boolean;
  token?: string;
  model: string;
  isCsvAvailable?: boolean;
  getTableDataForSelectedRows: any;
  isDeleteAvailable?: boolean;
  customButton1: any;
  headers: any[];
  tableDidFinishLoading: (action: any, message: string | null, error: string | undefined) => void;
  tableDidStartLoading: () => void;
};

function EnhancedTableToolbar({
  customButton1,
  headers,
  createButtonOnClick,
  isCreateAvailable,
  token,
  isUpdateAvailable,
  selected,
  updateButtonOnClick,
  model,
  isCsvAvailable,
  getTableDataForSelectedRows,
  isDeleteAvailable,
  tableDidStartLoading,
  tableDidFinishLoading,
}: EnhancedTableToolbarProps) {
  const headersForCsv = headers.filter(({ id }) => id === undefined);
  return (
    <Container>
      <Toolbar className={`table-header ${selected.length > 0 ? 'table-header-selected' : ''}`}>
        {selected.length > 0 ? (
          <Typography className="table-header-title" color="inherit" variant="subtitle1">
            {selected.length} selected
          </Typography>
        ) : (
          <Typography className="table-header-title" variant="h6" id="tableTitle">
            {/* this.props.title */}
          </Typography>
        )}

        {selected.length > 0 && isCsvAvailable && (
          <CsvButton
            getCsvData={() => getTableDataForSelectedRows({ isForCsv: true })}
            fileName="csvexport"
            headers={headersForCsv}
          />
        )}

        {selected.length > 0 && isDeleteAvailable && (
          <DeleteButton
            data={selected}
            token={token}
            tableDidStartLoading={tableDidStartLoading}
            tableDidFinishLoading={tableDidFinishLoading}
            model={model}
          />
        )}

        {selected.length === 1 && isUpdateAvailable && (
          <Tooltip title="Update selected rows">
            <IconButton onClick={updateButtonOnClick} aria-label="row">
              <EditIcon />
            </IconButton>
          </Tooltip>
        )}

        {selected.length === 0 && isCreateAvailable && (
          <Tooltip title="Create new record">
            <IconButton onClick={createButtonOnClick} aria-label="row">
              <AddIcon />
            </IconButton>
          </Tooltip>
        )}

        {selected.length === 1 && customButton1 && customButton1(selected)}
      </Toolbar>
    </Container>
  );
}

export default EnhancedTableToolbar;
